import { FuseNavigationItem } from "@fuse/components/navigation";
import { MenuModel } from "app/models/menu.model";

export class NavigationAdapter {
    static adapt(data: MenuModel): FuseNavigationItem {
        //console.log('Data in adapt:', data);
        if (!data) {
            return <FuseNavigationItem>{}; // Se data è undefined, restituisci un array vuoto
        }

        let res: FuseNavigationItem = {
            title: data.title,
            link: data.link,
            externalLink: data.link?.startsWith('http'),
            type: data.type,
            target: data.target ?? '_blank',
            icon: data.icon,
            queryParams: data.extraData,
            badge: {
                title: data.badgeText,
                classes: data.badgeColor ? 'badge-' + data.badgeColor : ''
            },
            children: []
        };

        // Se l'array children è vuoto, imposta il tipo su 'basic', altrimenti su 'collapsable'
        res.type = data.children && data.children.length > 0 ? 'collapsable' : 'basic';

        // Se ci sono children, adatta ciascuno di essi
        if (data.children) {
            data.children.forEach(child => {
                res.children.push(NavigationAdapter.adapt(child));
            });
        }

        return res;
    }
}
